import { Protocol } from '../Protocol';

export class MaterialPriceProtocol {

  public static readonly ALL_PRICE: string = `${Protocol.YATUNG_API_ROOT}/specification/cost/all`; // 取得所有原料單價
  public static readonly PRICE_URL: string = `${Protocol.YATUNG_API_ROOT}/specification/cost`; // 修改 & 新增所有原料單價
  public static readonly ADD_PRICE: string = `${Protocol.YATUNG_API_ROOT}/specification/cost/specs`; // 可新增單價的規格

}